<template>
  <el-dialog
    width="28%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @open="handleDialogOpen"
    @beforeClose="handleCloseDialog"
    :title="
      actionToPerform === 'ACTIVE'
        ? $t('Comn_culture')
        : $t('Comn_current_culture')
    "
    class="action-on-pond"
    custom-class="cultureAction_dialog"
  >
    <el-alert
      v-if="unhandledErrorMessage"
      :title="unhandledErrorMessage"
      type="error"
      @close="handleAlertClose"
    ></el-alert>

    <el-form size="small" :model="formPond" @submit.prevent="submitPondDetails">
      <el-form-item
        :label="formStrings.title.label"
        :error="castErrorKeyToLang(errMessagesObject.title)"
      >
        <el-col :span="24">
          <el-input
            class="input-pond-name"
            v-model="formPond.title"
            :placeholder="formStrings.title.placeholder"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item
        :label="formStrings.size.label"
        :error="castErrorKeyToLang(errMessagesObject.size)"
      >
        <el-col :span="24">
          <el-row type="flex" class="row-size">
            <el-col :span="12">
              <el-input
                class="input-pond-size"
                :precision="2"
                v-model.number="formPond.size"
                :controls="false"
                :min="0"
                @change="handleChangeInArea"
              ></el-input> </el-col
            >&nbsp;&nbsp;
            <span>
              <er-select
                :value="formPond.units"
                :controls="false"
                :min="0"
                class="select-size-units"
                @change="handleChangeAreaUnits"
              >
                <el-option
                  v-for="(unit, key) in units"
                  :key="unit"
                  :label="unit"
                  :value="key"
                ></el-option>
              </er-select>
            </span>
          </el-row>
        </el-col>
      </el-form-item>
      <el-form-item
        :label="formStrings.cultivation_date.label"
        :error="castErrorKeyToLang(errMessagesObject.cultivation_date)"
      >
        <el-col :span="24">
          <el-date-picker
            class="date-picker-stock-date"
            v-model="formPond.cultivation_date"
            type="date"
            value-format="yyyy-MM-dd"
            :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
            :clearable="false"
            :picker-options="pickerOptions"
            :placeholder="formStrings.cultivation_date.placeholder"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item
        :label="formStrings.post_larva_stocked.label"
        :error="castErrorKeyToLang(errMessagesObject.post_larva_stocked)"
      >
        <el-col :span="24">
          <el-input
            type="number"
            :min="1"
            title
            class="input-pl-stocked"
            :controls="false"
            v-model.number="formPond.post_larva_stocked"
            @change="handleChangePlStock"
            :placeholder="formStrings.post_larva_stocked.placeholder"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>

    <layout-toolbar slot="footer" justify="center">
      <er-button
        size="mini"
        btnType="save"
        :showLabel="true"
        :showIcon="true"
        :loading="loading"
        @click="submitPondDetails"
        :disabled="isReadOnly"
      ></er-button>
      <er-button
        size="mini"
        btnType="cancel"
        :showLabel="true"
        @click="handleCloseDialog('close')"
        :disabled="isReadOnly"
      ></er-button>
    </layout-toolbar>
  </el-dialog>
</template>

<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";
export default {
  mixins: [errorHandlerMixin, errorKeyMapMixin],
  props: {
    pond: {
      default: {
        type: "",
        name: "",
        feed_type: "",
        kg_dispensed_time: 0,
        status: "",
      },
    },
    showDialog: {
      default: false,
    },
    actionToPerform: {
      default: "",
    },
  },
  data: function() {
    return {
      formPond: this.pond,
      loading: false,
      newErrorMessageObject: {
        title: "",
        size: "",
        units: "",
        pond_id: "",
        cultivation_date: "",
        post_larva_stocked: "",
      },
      errMessagesObject: {
        title: "",
        size: "",
        units: "",
        pond_id: "",
        cultivation_date: "",
        post_larva_stocked: "",
      },
      backndfieldToFieldNameMap: {
        title: "Comn_pond_name",
        size: "Comn_size",
        post_larva_stocked: "Pond_pls_stocked",
      },
      backndfieldToInvalidMap: {
        size: { INVALID_VALUE: "Map_pond_size_greater0" },
        post_larva_stocked: {
          INVALID_VALUE: "Comn_pls_count_not_empty",
          VALUE_SHOULD_BE_A_SAFE_NUMBER: 1000000000000,
        },
      },
    };
  },
  computed: {
    isReadOnly() {
      return this.$store.getters["user/isReadOnly"];
    },
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.handleCloseDialog("close");
      },
    },
    units: function() {
      return {
        ha: this.$t("Pond_size_units_ha"),
        ac: this.$t("Pond_size_units_ac"),
      };
    },
    formStrings() {
      return {
        status: {
          label: this.$t("Comn_status"),
          placeholder: this.$t("Comn_status"),
        },
        post_larva_stocked: {
          label: this.$t("Pond_pls_stocked"),
          placeholder: this.$t("Pond_pls_stocked"),
        },
        title: {
          label: this.$t("Comn_pond_name"),
          placeholder: this.$t("Comn_pond_name"),
        },
        size: {
          label: this.$tc("Pond_size", 1),
          placeholder: this.$tc("Pond_size", 1),
        },
        cultivation_date: {
          label: this.$t("Comn_stocking_date"),
          placeholder: this.$t("Comn_stocking_date"),
        },
        units: {
          placeholder: this.$t("Comn_units"),
        },
      };
    },
    pickerOptions: function() {
      const { cultivation_date, cultivations } = this.formPond;

      return {
        disabledDate: (time) => {
          if (!cultivations.length > 0) {
            return time.getTime() > Date.now();
          } else {
            return (
              time.getTime() <=
                this.$moment(cultivations[cultivations.length - 1].end_date) ||
              time.getTime() > Date.now()
            );
          }
        },
      };
    },
  },
  methods: {
    handleChangeInArea(value) {
      if (!+value) {
        this.formPond.size = 0;
      }
    },
    handleDialogOpen() {
      this.formPond = this.pond;
      this.formPond.cultivation_date = this.$moment(
        this.formPond.cultivation_date || new Date()
      ).format("YYYY-MM-DD");
    },
    handleCloseDialog(event) {
      this.errMessagesObject = this.$lodash.cloneDeep(
        this.newErrorMessageObject
      );
      this.$emit("close_dialog", event);
    },
    handleChangeAreaUnits(newUnitsSelected) {
      console.log(newUnitsSelected);
      this.formPond.size = this.$commonUtils.castPondAreaSize(
        this.formPond.size,
        this.formPond.units,
        newUnitsSelected
      );
      this.formPond.units = newUnitsSelected;
    },
    error409Handler: function(err) {
      if (err.response.data.error_code === "POND_TITLE_ALREADY_TAKEN") {
        this.$notify({
          title: this.$t("failed"),
          message: this.$t("Ponds_name_already_in_use_choose_different"),
          type: "error",
          duration: 4500,
        });
      } else {
        this.$notify({
          title: this.$t("failed"),
          message: this.$t("Something_went_wrong"),
          type: "error",
          duration: 4500,
        });
      }
    },
    handleChangePlStock(value) {
      if (!+value) {
        this.formPond.post_larva_stocked = 0;
      }
    },
    async submitPondDetails() {
      try {
        this.loading = true;
        // this.formPond.cultivation_date += "T00:00:00.000Z";
        let {
          title,
          size,
          units,
          pond_id,
          cultivation_date,
          post_larva_stocked,
        } = this.formPond;
        post_larva_stocked = +post_larva_stocked;
        cultivation_date = cultivation_date + "T00:00:00.000Z";
        let storeAction = null;
        let payload = null;
        storeAction = "pond/updatePondDetails";
        payload = {
          title,
          size,
          units,
          pond_id,
          cultivation_date,
          post_larva_stocked,
          status: "ACTIVE",
        };
        const response = await this.$store.dispatch(storeAction, payload);
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t(
            this.actionToPerform === "ACTIVE"
              ? "Comn_pond_activated_successfully"
              : "Pond_data_upd_success",
            { pond_name: title }
          ),
          duration: 5000,
          type: "success",
        });
        this.handleCloseDialog("pond-action-" + this.actionToPerform);
        console.log(response);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.action-on-pond {
  $width: 200px;
  .el-dialog__body {
    padding: 15px 15px;
  }
  .input-pond-name {
    width: $width !important;
  }
  .row-size {
    position: relative;
    width: $width;
    .select-size-units {
      .el-input__inner {
        padding-right: 26px;
        @include responsiveProperty(width, 100px, 120px, 140px);
      }

      width: unset;
      box-sizing: border-box;
      position: relative;
    }
    .input-pond-size {
      width: unset;
      box-sizing: border-box;
      position: relative;
      .el-input__inner {
        width: 100px;
      }
    }
  }
  .input-pl-stocked {
    width: $width !important;
    .el-input__inner {
      text-align: left !important;
    }
  }
  .date-picker-stock-date {
    width: $width !important;
    .el-input__inner {
      text-align: left;
    }
  }
}

.cultureAction_dialog {
  background: #fcfcfc;
  border-radius: 10px;

  .el-input--small .el-input__inner {
    @include responsiveProperty(width, 205px, 227px, 250px);
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    @include responsiveProperty(min-width, 100px, 130px, 190px);
  }
}
</style>
